import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { HelpersService } from "../../../../core/services/helpers.service";
import { ModalNotifyService } from "../../../../core/services/modal-notify.service";
import { OperationsService } from '../../../../core/services/operations.service';
import { DocumentoAllegato } from "../../../models/documento-allegato";
import { FileFolders } from '../../fascicolo/documentazione-allegata-view/documentazione-allegata.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { Subscription } from 'rxjs';
import {SignDocumentDialogComponent} from "../../../sign/document/components/dialog/sign-document-dialog.component";
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import { MarkDocumentDialogComponent } from 'src/app/common/mark/document/components/dialog/mark-document-dialog.component';
import { ViewDocumentDialogComponent } from '../../view-document-dialog/view-document-dialog.component';
import { EXTENSIONS, mimeExtensionMap } from '../../file-preview/eml/eml-preview.component';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { Router } from '@angular/router';
import { UserProfileFlagStore } from 'src/app/utility/store/user-profile-flag';
import { DocPreviewUtilityService } from '../../file-preview/doc-preview-utility.service';
import { AnnullaDocumentoProtocolloComponent } from 'src/app/common/protocol/components/fascicolo/dialog/annulla-documento-protocollo/annulla-documento-protocollo.component';
import { SelezioneFascicoliSecondariComponent } from 'src/app/common/protocol/components/fascicolo/dialog/selezione-fascicoli-secondari/selezione-fascicoli-secondari.component';

declare var openModal: any;
declare var closeModal: any;
@Component({
  selector: 'app-detail-folder-file',
  templateUrl: './detail-folder-file.component.html',
  styleUrls: ['./detail-folder-file.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DetailFolderFileComponent implements OnInit, OnChanges {
  @ViewChildren('options') options: QueryList<ElementRef>;
  @ViewChildren('content') content: QueryList<ElementRef>;
  @ViewChild('docShowEliminaDirModal') docShowEliminaDirModal!: ElementRef<HTMLDivElement>;
  @Input() itemSelected: FileFolders;
  @Input() addDocFormTitles: Array<string>;
  @Input() separatorePathLogico: string;
  @Input() refreshData: boolean;
  @Input() minervaWizard: boolean = false;
  @Input() fascicolo: any;
  @Output() setRefreshData = new EventEmitter();
  @Output() onClickUpdateDocVersion = new EventEmitter();
  @Output() onClickShowVersionHistory = new EventEmitter();
  @Output() onClickAddDocument = new EventEmitter();
  @Output() onClickAddFolder = new EventEmitter();
  @Output() onClickRemoveDocument = new EventEmitter();
  @Output() onClickRemoveDocumentWithFascicolo = new EventEmitter<{ documento: any, nuovoFascicolo: any }>();
  @Output() onClickMoveDocument = new EventEmitter();
  @Output() onClickUpdateMetadatiModal = new EventEmitter();
  @Output() onReturnUpdate = new EventEmitter();
  @Output() onOpenProtocolDocModal= new EventEmitter();
  @Output() onOpenProtocolDocSelection = new EventEmitter();
  @Output() from = new EventEmitter();
  @Output() to = new EventEmitter();
  @Output() updateItemSelected = new EventEmitter();
  @Output() onGoSectionRoot = new EventEmitter();
  @Output() onGoSectionChild = new EventEmitter();
  @Output() onUploadFileService = new EventEmitter();
  @Output() exportFile = new EventEmitter();
  @Output() esn = new EventEmitter();
  @Output() onDocSigned = new EventEmitter();
  @Output() onDocMarked = new EventEmitter();
  @Output() isFolder = new EventEmitter();
  @Output() annullaEvent = new EventEmitter();

  public isDragAction: boolean;
  public isDragOver: boolean;
  showDetail: boolean;
  isEliminaDir: boolean;
  docToDetail: DocumentoAllegato;
  docToRemove: DocumentoAllegato;
  sezione: string;
  protocolSubscription: Subscription;
  isDragFolder: boolean;
  isFileOnFile: boolean = false;
  sortDirection: 'asc' | 'desc' = 'asc';
  // public loading: boolean;
  // fileUploadList: DocumentoAllegato[] = [];
  // public fileData: FileData = new FileData();
  // private XSRF: string;

  sezioneMapping = {
    'SezioneAtti': 'atti',
    'SezioneEsiti': 'esiti',
    'SezioneScadenze': 'scadenze',
    'SezioneIncassi': 'incassi',
    'SezioneFatture': 'fatture',
    'SezioneAltreParti': 'altreParti', //sggett terzi
    'SezioneControparti': 'controparti',
    'SezioneLegali': 'legaliIncaricati',
    'SezioneParcelle': 'parcelle',
    'SezionePagamenti': 'pagamenti',
    'SezioneProveScritte': 'proveScritte',
    'SezioneBeniImmobili': 'beniPignoratiImmobili',
    'SezioneDatiPignoramento': 'datiPignoramento',
    'SezioneBeniMobili': 'beniPignoratiMobili',
    'SezioneTitoliEsecutivi': 'titoliEsecutivi'
  }


  constructor(
    private renderer: Renderer2,
    private helpersService: HelpersService,
    private modalNotifyService: ModalNotifyService,
    private ops: OperationsService,
    private modal: DialogService,
    private router: Router,
    private docPreviewUtility: DocPreviewUtilityService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.itemSelected) {
      this.sortItems("dataRiferimento");  
    }
    if (changes.refreshData && changes.refreshData.previousValue !== undefined && !!this.refreshData) {
      this.options.forEach((eleRef: ElementRef) => {
        this.renderer.removeClass(eleRef.nativeElement, 'drag-over');
      });
      this.content.forEach((eleRef: ElementRef) => {
        this.renderer.removeClass(eleRef.nativeElement, 'drag-over');
      });
      this.setRefreshData.emit(false);
    }
  }

  openProtocolDisclaimer(documento: DocumentoAllegato) {
    documento.primary = true;
    this.onOpenProtocolDocSelection.emit(documento);
  }

  split(list) {
    if (this.itemSelected.section.isMain) {
      return list.split(this.separatorePathLogico);
    } else {
      return [list];
    }
  }

  goSectionRoot() {
    this.onGoSectionRoot.emit(this.itemSelected.section.nomeCampoId);
  }

  goSectionChild(itemPath) {
    this.onGoSectionChild.emit({ itemPath, sectionRootId: this.itemSelected.section.nomeCampoId });
  }

  isFile(item: FileFolders) {
    return !!item?.documento?.refDocumentale || !!item?.documento?.missingFile;
  }

  getExtFile(item: FileFolders) {
    const re = /(?:\.([^.]+))?$/;
    return re.exec(item.path)[1];
  }

  getSezione(sezione) {
    this.sezione = sezione;
  }

  getExpandCollapseClass(item: FileFolders) {
    if (item.documento.refDocumentale || item.documento.missingFile) {
      // Se il documento ha una refDocumentale, controllo il flag di timbratura
      if (item.documento.flagTimbratura) {
        return 'documento-timbrato';
      }
      return 'glyphicon glyphicon-file'; // Se non c'è timbratura, restituisco l'icona del file
    } else {
      return 'glyphicon glyphicon-folder-close';
    }
  }


  toggleSelection(evt, item) {
    // this.itemSelected = item;
    this.updateItemSelected.emit(item);
  }

  dragOver(ev, item) {
    // console.log(item);
    if(this.isFile(item)) {
      console.log('dragOver')
      ev.preventDefault();
      ev.stopPropagation();
      this.options.forEach((eleRef: ElementRef) => {
        const code = eleRef.nativeElement.getAttribute('data-code');
        if (code == item["code"] && !this.isFile(item)) {
          this.renderer.addClass(eleRef.nativeElement, 'drag-over');
          this.isDragOver = false;
        } else {
          this.renderer.removeClass(eleRef.nativeElement, 'drag-over');
        }
      });
      // this.isDragOver = true;
      this.isFileOnFile = true;
    }

  }

  dragStart(ev, item) {
    // console.log('From: ', item);
    if(!this.isFile(item)) {
      this.isDragFolder = true;
      this.isFolder.emit(true);
    } else {
      this.from.emit(item);
      this.isFolder.emit(false);
    }
    console.log('dragStart')

    this.isDragAction = true;
    ev.stopPropagation();
    // ev.dataTransfer.setData("text", ev.target.id);

  }

  drop(ev, item) {
    // console.log('To: ', item);
      console.log('drop');
    if(!this.isDragFolder) {
      this.to.emit(item);
      this.isDragAction = false;
      this.isDragOver   = false
      ev.preventDefault();
      ev.stopPropagation();
      // const data = ev.dataTransfer.getData('text');
      // console.log(data);
      this.renderer.removeClass(ev.currentTarget, 'drag-over');
      this.options.forEach((eleRef: ElementRef) => {
        this.renderer.removeClass(eleRef.nativeElement, 'drag-over');
      });
      // ev.target.appendChild(document.getElementById(data));

      const files = ev.dataTransfer.files;
      if (files.length > 0) {
        // this.uploadFileService(files);
        this.onUploadFileService.emit(files);
      } else {
        /* TODO: move file/dir */
      }
    }
  }

  dropFileDesktop(ev) {
    console.log('dropFileDesktop')
    console.log('To: (container)', ev);
    console.log('itemSelected:', this.itemSelected);
    if(!this.isDragFolder && !this.isFileOnFile) {
      this.to.emit(this.itemSelected);
      ev.preventDefault();
      // ev.stopPropagation();
      this.isDragOver = false;

      this.options.forEach((eleRef: ElementRef) => {
        this.renderer.removeClass(eleRef.nativeElement, 'drag-over');
      });

      const files = ev.dataTransfer.files;
      if (files.length > 0) {
        // this.uploadFileService(files);
        this.onUploadFileService.emit(files);
      } else {
        /* TODO: move file/dir */
        // this.showMoveDocumentModal(documento);
      }
    } else {
      this.modal.open(ConfirmModalComponent, {
        data: {
          style: { width: "50%" },
          modalConfirm: {
            text: 'Non è possibile spostare l\'elemento',
            data: [],
            hideButtons: true,
            confirmButton: true
          },
          title: 'Attenzione',
        }
      });
      this.isDragFolder = false;
      this.isFileOnFile = false;
    }



  }

  dragOverFileDesktop(ev) {
    console.log('dragOverfileDesktop');
    // console.log(ev);
    ev.preventDefault();
    // ev.stopPropagation();
    this.isDragOver = true;
    this.options.forEach((eleRef: ElementRef) => {
      this.renderer.removeClass(eleRef.nativeElement, 'drag-over');
    });

  }

  downloadFile(idDocumento, documento: DocumentoAllegato) {
    if (documento.refDocumentale) {
      if (idDocumento) {
        this.helpersService.downloadDocument(idDocumento).subscribe();
      }
      else {
        this.helpersService.downloadDocumentoByIdDocumentale(documento.refDocumentale, documento.versione).subscribe();
      }
    }
  }

  salvaFile(content, fileName) {
    var FileSaver = require('file-saver')
    const byteCharacters = atob(content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/octet-stream"
    });
    const name = fileName;
    try {
      FileSaver.saveAs(blob, name);
    } catch (err) {
      window.navigator.msSaveBlob(blob, fileName);
    }
  }

  /*** EMIT CALLBACK ***/
  showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.onClickUpdateDocVersion.emit(documento);
  }

  showHistoryModal(documento: DocumentoAllegato) {
    this.onClickShowVersionHistory.emit(documento);
  }

  showAddDocModal(nomeCampoId, item) {
    if (item.section.nomeCampoId != 'idSezioneDocumentazioneAllegata') {
      if (item.section[this.sezioneMapping[item.section.esn]].length > 0) {
        this.onClickAddDocument.emit(this.addDocFormTitles[item.section.nomeCampoId]);
      } else {
        this.modalNotifyService.messaggioCustom("Non sono presenti elementi nella sezione " + item.name + ". E' necessario inserire almeno un elemento per poter allegare un documento.", 'Attenzione');
      }
    } else {
      this.onClickAddDocument.emit(this.addDocFormTitles[item.section.nomeCampoId]);
    }

    // this.onClickAddDocument.emit(nomeCampoId);
  }

  showAddFolderModal(nomeCampoId) {
    this.onClickAddFolder.emit(this.addDocFormTitles[nomeCampoId]);
  }

  showMoveDocumentModal(event) {
    this.onClickMoveDocument.emit(event);
  }

  showUpdateMetadatiModal(documento: DocumentoAllegato) {
    this.esn.emit(this.sezione)
    this.onClickUpdateMetadatiModal.emit(documento);
  }

  showProtocolModal(documento: DocumentoAllegato, fascicoloId?:string) {
    this.onOpenProtocolDocModal.emit(documento);
  }

  exportFileFn(nomeCampoId, item) {
    if (item.code != 'idSezioneDocumentazioneAllegata') {
      if (item.section[this.sezioneMapping[item.section.esn]].length > 0) {
        this.exportFile.emit(this.addDocFormTitles[nomeCampoId]);
      } else {
        this.modalNotifyService.messaggioCustom("Non sono presenti elementi nella sezione " + item.name + ". E' necessario inserire almeno un elemento per poter allegare un documento.", 'Attenzione');
      }
    } else {
      this.exportFile.emit(this.addDocFormTitles[nomeCampoId]);
    }
  }

  showDetailModal(documento: DocumentoAllegato) {
    this.docToDetail = documento;
    this.showDetail = true;
    openModal('docShowDetailModal');
  }

  closeDetailModal() {
    this.showDetail = false;
    closeModal('docShowDetailModal');
  }

  checkProtocolNumber(documento: DocumentoAllegato) {
    if(!this.fascicolo.dataProtocollazione ){
    this.protocolSubscription = this.modalNotifyService.notifyConfirmObservable.subscribe(result => {
      if (!!result) {
      this.showProtocolModal(documento)
    } else{
      this.protocolSubscription.unsubscribe();
    }})
    this.modalNotifyService.notifyCustom('Il Fascicolo non è ancora collegato al Protocollo; i valori risultanti dalla protocollazione di questo documento verranno associati al Fascicolo. Procedere?');
    }
    else {
      this.showProtocolModal(documento,this.fascicolo.id)
    }
  }

  showDeleteDirModal(documento: DocumentoAllegato) {
    this.docToRemove = documento;
    this.isEliminaDir = true;
    openModal('docShowEliminaDirModal');
    setTimeout(() => this.docShowEliminaDirModal.nativeElement.focus());
  }

  confermaEliminaDir() {
    this.onClickRemoveDocument.emit(this.docToRemove);
    this.docToRemove = null;
    closeModal('docShowEliminaDirModal');
    this.isEliminaDir = false;
  }

  removeDoc(documento: DocumentoAllegato) {
    this.onClickRemoveDocument.emit(documento);
  }
  // removeDocFromSezioneConFascicolo(documento: DocumentoAllegato) {
  //   //da gestire
  // }

  removeDocFromSezioneConFascicolo(event: { documento, nuovoFascicolo }, sezione) {
   this.onClickRemoveDocumentWithFascicolo.emit(event);
  }

  onReturnUpdateCallback(response) {
    this.onReturnUpdate.emit(response);
  }

  getNameFile(nameFile) {
    return nameFile.split(this.separatorePathLogico).slice(-1)[0];
  }

  firmaDoc(documento: DocumentoAllegato,itemSelected: FileFolders) {
    const ref = this.modal.open(SignDocumentDialogComponent, {
      data: {
        document: documento,
        style: { width: "50%" }
      }
    })

    const sub = ref.afterClosed.subscribe(event => {
      if (event.modalEvent) {
        this.onDocSigned.emit(itemSelected);
      }
      sub.unsubscribe();
    });

  }

  timbraDoc(documento: DocumentoAllegato,itemSelected: FileFolders) {
    const ref = this.modal.open(MarkDocumentDialogComponent, {
      data: {
        document: documento,
        idFascicolo: this.fascicolo.id,
        style: { width: "50%" }
      }
    })
  //Quando la modale viene chiusa, mi assicuro che l'evento modalEvent venga emesso
  // prima di eseguire onDocMarked.emit(itemSelected)
    const sub = ref.afterClosed.subscribe(event => {
      if (event.modalEvent) {
        this.onDocMarked.emit(itemSelected);
      }
      sub.unsubscribe();
    });

  }

  annullaProtocolDoc(documento: DocumentoAllegato, itemSelected?: FileFolders) {
      if (!!documento.flagAttoPrincipale) {
        this.helpersService.searchByProtocollo(documento.numeroProtocollo, false)
          .subscribe(result => {
            if (result && result.length > 0) {
              // ci sono altri fascicoli: apro la modale di selezione
              const messaggio = `Stai per annullare l’associazione del protocollo ${documento.numeroProtocollo} al fascicolo principale ${this.fascicolo.posizione}.`;
              const refSel = this.modal.open(SelezioneFascicoliSecondariComponent, {
                data: {
                  style: { width: "50%" },
                  title: "Seleziona fascicolo ricevente",
                  message: messaggio,
                  fascicoliDisponibili: result ?? [],
                  fascicoloCorrente: this.fascicolo // o il contesto che usi
                }
              });
  
              refSel.afterClosed.pipe().subscribe(event => {
                if (!event) return; // annullato
                if (event.modalEvent === true) {
                  const selectedFascicolo = event.selectedFascicolo ?? null;
                  // ora apro la modale di annullamento passando l'eventuale selectedFascicolo
                  this.openAnnullaDialogWithTarget(documento, itemSelected,selectedFascicolo);
                }
              });
            } else {
              // nessun altro fascicolo: apro direttamente l'annulla dialog
              this.openAnnullaDialogWithTarget(documento,itemSelected, null);
            }
          });
      } else {
        // non è atto principale apro direttamente
        this.openAnnullaDialogWithTarget(documento, itemSelected,null);
      }
    }
  
    /**
     * Apro la modale di annullamento passandole un eventuale nuovo fascicolo destinatario.
     */
    private openAnnullaDialogWithTarget(documento: DocumentoAllegato,itemSelected:FileFolders, selectedFascicolo: any | null) {
      const ref = this.modal.open(AnnullaDocumentoProtocolloComponent, {
        data: {
          document: documento,
          idFascicolo: this.fascicolo.id,
          targetFascicolo: selectedFascicolo,
          style: { width: "50%" }
        }
      });
  
      const sub = ref.afterClosed.subscribe(result => {
        if (result?.modalEvent && result.data) {
        // result.data contiene estremiProvvedimento, dataAnnullamento, identificativoOperatore...
        const annullamento = result.data;
        documento.estremiProvvedimento = annullamento.estremiProvvedimento;
        documento.dataAnnullamento = annullamento.dataAnnullamento
          ? new Date(annullamento.dataAnnullamento).getTime()
          : new Date().getTime(); 
        documento.identificativoOperatore = annullamento.identificativoOperatore;
       
        const payload: any = {
          idDocumentoDaAnnullare: documento.id,
          idFascicolo: selectedFascicolo?.idFascicolo,
          idSezione:  itemSelected.section.id,
          estremiProvvedimento: documento.estremiProvvedimento,
          dataAnnullamento: documento.dataAnnullamento,
          identificativoOperatore: documento.identificativoOperatore
        };
        this.ops.annullaProtocollazione(payload).subscribe({
        next: (resp) => {
          this.annullaEvent.emit(resp);
        },
        error: (err) => {
          console.log('Errore annullamento protocollazione', err);
        }
      });
      }
      sub.unsubscribe();
    });
    }

  canViewFile(documento: DocumentoAllegato){
    let maxPreviewSize = this.docPreviewUtility.findMaxSizeByContentype(documento.contentType);
    // controllo che il contenuto del file non superi la dimensione massima consentita
    if(documento.contentSize > Number(!!maxPreviewSize ? maxPreviewSize : documento.contentSize)) {
      return false;
    };
    return documento && 
    documento.nomeFile && (
      documento.nomeFile.includes(".pdf") || 
      documento.nomeFile.includes(".eml") || 
      documento.nomeFile.includes(".zip") || 
      documento.nomeFile.includes(".p7m")
    );
  }

  checkMaxLimitExceeded(documento: DocumentoAllegato):boolean {
    let maxPreviewSize = this.docPreviewUtility.findMaxSizeByContentype(documento.contentType);
    if(documento.contentSize > Number(!!maxPreviewSize ? maxPreviewSize : documento.contentSize)) {
      return true;
    }
    return false;
  }

  viewDoc(documento: DocumentoAllegato) {
    let mimeTypes = mimeExtensionMap;
    this.previewNavigate(documento, mimeTypes[documento.contentType]);
  }

  previewNavigate(documento: DocumentoAllegato, contentType: string) {
    let fullUrl = null;
    let urlTree = null;
    let urlSerialized = null;
    switch (contentType) {
      case EXTENSIONS.EML:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_EML_FILE_PREVIEW, documento.id]);
        break;
      case EXTENSIONS.ZIP:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_ZIP_FILE_PREVIEW, documento.id]);
        break;
      case EXTENSIONS.PDF:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_PDF_FILE_PREVIEW, documento.id]);
        break;
      case EXTENSIONS.P7M:
        urlTree = this.router.createUrlTree([UrlSettingsCore.URL_PDF_FILE_PREVIEW, documento.id, 'p7m']);
        break;
      default:
        this.helpersService.viewDoc(documento);
        break;
    }
    if(!urlTree) return;
    urlSerialized = this.router.serializeUrl(urlTree);
    fullUrl = `${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#${urlSerialized}?nomeFile=${documento.nomeFile}`;
    window.open(fullUrl, '_blank');
  }

  isFilePresent(documento): boolean {
      return documento?.missingFile !== true;
  }

  setFocus(item: any){
    if(!this.isFile(item)) document.getElementById('datail-folder-file').focus();
  }

  sortColumnTreeView(field: string): void {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortItems(field);
  }

  sortItems(field: string): void {
    if(!this.itemSelected) return;
    const childrenWithValue = this.itemSelected?.children.filter(
      child => child.documento && child.documento[field] != null
    );

    const sortedChildren = [...childrenWithValue].sort((a, b) => {
      const valueA = a.documento[field];
      const valueB = b.documento[field];

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    // mantengo anche i null ma in fondo, li aggiungo successivamente:
    const childrenWithoutValue = this.itemSelected?.children.filter(
      child => !child.documento || child.documento[field] == null
    );

    // Ricrea l’oggetto con i nuovi array ed aggiundo i null precedentemente esclusi
    this.itemSelected = {
      ...this.itemSelected,
      children: [...sortedChildren, ...childrenWithoutValue]
    };

    this.cdr.detectChanges();
  }

  orderByType(children: FileFolders[]): FileFolders[] {
    const arrayChild = children.sort((a, b) => {
      if (a.documento.refDocumentale && b.documento.refDocumentale) {
        return 0;
      } else if (!a.documento.refDocumentale && b.documento.refDocumentale) {
        return -1;
      } else if (a.documento.refDocumentale && !b.documento.refDocumentale) {
        return 1;
      } else {
        return 0;
      }
    });
    return arrayChild;
  }

  resolveValue(item: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc && acc[part], item);
  }

  hasFirmaNonValida(documento: DocumentoAllegato): boolean {
    if (!documento) return false;
    if (documento.statoDocumento !== 'FORMATO') {
      return false;
    }
    const firme = documento.metadatoFirmaDocumenti;

    if (!Array.isArray(firme) || firme.length === 0) {
      return false;
    }

    return firme.some(f => f.esitoVerifica.id === 'NON_VALIDA');
  }

}
